import { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';

let _cache = null;
let _inflight = null;
const _listeners = new Set();

function notify() {
  for (const fn of _listeners) fn(_cache || []);
}

async function loadProjectTypes() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios.get('/api/v1/project-types')
    .then((r) => {
      _cache = (r.data && r.data.data) || [];
      notify();
      return _cache;
    })
    .catch(() => {
      _cache = [];
      notify();
      return _cache;
    })
    .finally(() => { _inflight = null; });
  return _inflight;
}

export function warmProjectTypes() {
  return loadProjectTypes();
}

export function getCachedProjectTypes() {
  return _cache || [];
}

export function getProjectTypeLabel(typeCd) {
  if (!typeCd) return '';
  const t = (_cache || []).find((x) => x.type_cd === typeCd);
  return (t && t.type_label) || typeCd;
}

export function getProjectTypePluralLabel(typeCd) {
  if (!typeCd) return '';
  const t = (_cache || []).find((x) => x.type_cd === typeCd);
  return (t && t.plural_label) || typeCd;
}

export function getProjectTypeBreakdownLabel(typeCd) {
  if (!typeCd) return '';
  const t = (_cache || []).find((x) => x.type_cd === typeCd);
  return (t && (t.description || t.type_label)) || typeCd;
}

export function useProjectTypes() {
  const [types, setTypes] = useState(_cache || []);
  useEffect(() => {
    let mounted = true;
    const listener = (next) => { if (mounted) setTypes(next); };
    _listeners.add(listener);
    if (_cache) {
      setTypes(_cache);
    } else {
      loadProjectTypes();
    }
    return () => { mounted = false; _listeners.delete(listener); };
  }, []);
  return types;
}
